import { IconBell16 } from '@warp-ds/icons/react';
import { Button } from '@warp-ds/react';
import { useState } from 'react';
import { useConfig } from 'shared/config/ConfigContext';
import { postSaveSearch } from '@/api/api';
import type { AutocompleteData, Filters } from '@/domain';
import { useToast } from '@/scenes/resultPage/context/toast/ToastProvider';
import { SaveSearchModal } from '../saveSearchModal/SaveSearchModal';

export interface SaveSearchProps {
    filters: Filters;
    autocompleteData: AutocompleteData;
    isLoggedIn: boolean;
}

export const SaveSearch = ({ filters, autocompleteData, isLoggedIn }: SaveSearchProps) => {
    const { apiExternalUrl } = useConfig();
    const [isOpen, setOpen] = useState(false);
    const { toast } = useToast();

    const saveSearch = (name: string, notify: boolean) => {
        postSaveSearch(apiExternalUrl, name, notify, filters)
            .then((response) => (response ? Promise.resolve() : Promise.reject()))
            .then(() => {
                toast({ message: 'Søket er lagret!' });
            })
            .catch(() => {
                toast({ message: 'Det skjedde en feil og søket ble ikke lagret. Prøv igjen!', type: 'error' });
            });
    };

    return (
        <>
            <Button
                utility
                data-testid="saveSearchButtonDesktop"
                className="hidden md:flex items-center gap-4"
                onClick={() => setOpen(true)}>
                <IconBell16 aria-label="Bjelle" />
                Lagre søk
            </Button>
            <Button small utility data-testid="saveSearchButtonMobile" className="flex md:hidden min-w-8" onClick={() => setOpen(true)}>
                <IconBell16 aria-label="Lagre søk, bjelle" />
            </Button>
            <SaveSearchModal
                saveSearch={saveSearch}
                query={autocompleteData.selectedValue}
                isOpen={isOpen}
                setOpen={setOpen}
                isLoggedIn={isLoggedIn}
            />
        </>
    );
};
